// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Image__container-c5c32b {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  background-size: cover;
  background-position: center center;
  cursor: pointer;
  max-width: var(--max-width-article-layout);
  max-height: 400px;
  border-radius: 16px;
  background-color: var(--base-17);
}

.Image__image-ff7c91 {
  background-color: var(--base-20);
  max-height: 100%;
  max-width: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  position: relative;
}

.Image__backdrop-ad961b {
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  filter: blur(25px);
}

@supports (backdrop-filter: blur(25px)) {
  .Image__backdrop-ad961b {
    filter: none;
  }
  .Image__backdrop-ad961b:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(25px);
  }
}
.Image__uploader-cbe0f8 {
  color: var(--addition-50);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 48px;
  height: 48px;
  background-color: var(--addition-40_60);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Image__icon-d18096 {
  fill: var(--addition-50);
}

.Image__error-icon-cadb92 {
  opacity: 0.6;
  width: 48px;
  height: 48px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/Article/ArticleRedactor/Payloads/Image/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kCAAA;EACA,eAAA;EACA,0CAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;AACF;;AAEA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AACA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;AAEF;;AACA;EACE;IACE,YAAA;EAEF;EAAA;IACE,WAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,2BAAA;EAEF;AACF;AACA;EACE,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,YAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n  background-size: cover;\n  background-position: center center;\n  cursor: pointer;\n  max-width: var(--max-width-article-layout);\n  max-height: 400px;\n  border-radius: 16px;\n  background-color: var(--base-17);\n}\n\n.image {\n  background-color: var(--base-20);\n  max-height: 100%;\n  max-width: 100%;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  position: relative;\n}\n.backdrop {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n  filter: blur(25px);\n}\n\n@supports (backdrop-filter: blur(25px)) {\n  .backdrop {\n    filter: none;\n  }\n  .backdrop:after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    backdrop-filter: blur(25px);\n  }\n}\n\n.uploader {\n  color: var(--addition-50);\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 48px;\n  height: 48px;\n  background-color: var(--addition-40_60);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.icon {\n  fill: var(--addition-50);\n}\n\n.error-icon {\n  opacity: 0.6;\n  width: 48px;\n  height: 48px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Image__container-c5c32b`,
	"image": `Image__image-ff7c91`,
	"backdrop": `Image__backdrop-ad961b`,
	"uploader": `Image__uploader-cbe0f8`,
	"icon": `Image__icon-d18096`,
	"error-icon": `Image__error-icon-cadb92`,
	"errorIcon": `Image__error-icon-cadb92`
};
module.exports = ___CSS_LOADER_EXPORT___;
